import React from 'react';
import './LimitExceededModal.css'; // Reuse existing modal styles

function DeleteConfirmationModal({ isOpen, onConfirm, onCancel }) {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h2>Удалить документ</h2>
        <p>Вы уверены, что хотите удалить этот документ? Это действие невозможно отменить.</p>
        <div className="modal-buttons">
          <button className="modal-button secondary" onClick={onCancel}>
            Отмена
          </button>
          <button className="modal-button primary" onClick={onConfirm}>
            Удалить
          </button>
        </div>
      </div>
    </div>
  );
}

export default DeleteConfirmationModal;